import React from 'react';
import {
  Button,
} from '@mui/material';
import jMoment from 'moment-jalaali';
import { Link } from 'react-router-dom';
import {
  SUBSCRIPTION_TYPES,
  PERIOD_TYPES,
} from '../../constants/SubscriptionConstants';
import { TableItemActionsNew , Icons, PriceLabel} from 'components';

const columns = (actionsList, onClickEdit, setDedicatedActivation, setSubscriptionType , currencyText) => [
  {
    title: 'ردیف',
    field: 'num',
    filtering: false,
    sorting: false,
    align: 'center',
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
  },
  {
    title: 'نام  طرح',
    field: 'name',
    filtering: false,
    sorting: false,
  },
  {
    title: 'نوع طرح',
    field: 'typeCode',
    filtering: false,
    sorting: false,
    render: (rd) => {
      const v = SUBSCRIPTION_TYPES.find((v) => v?.value === rd?.typeCode);
      return v?.label ?? '-';
    },
  },
  {
    title: `مبلغ (${currencyText})`,
    field: 'price',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rd) => (<PriceLabel amount={rd?.price} />),
  },
  {
    title: 'تاریخ ایجاد',
    field: 'creationDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) =>
      rc?.creationDate ? jMoment(rc.creationDate).format('dddd, jD jMMMM jYYYY') : '-',
  },

  {
    title: 'بازه زمانی',
    field: 'expireDate',
    align: 'center',
    filtering: false,
    sorting: false,
    render: (rc) => {
      if (!rc?.periodTypeCode || !rc?.periodCount) return '-';
      const v = PERIOD_TYPES.find((v) => v?.value === rc?.periodTypeCode);
      return `${rc?.periodCount ?? ''} ${v?.shortLabel ?? ''}`;
    },
  },
  {
    title: `محدودیت مبلغ (${currencyText})`,
    field: 'usageAmountLimit',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rd) => (rd?.usageAmountLimit ? <PriceLabel amount={rd?.usageAmountLimit} /> : '-'),
  },
  {
    title: 'محدودیت دفعات استفاده',
    field: 'usageCountLimit',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rd) => rd?.usageCountLimit ?? '-',
  },
  {
    title: 'یک بار مصرف',
    field: 'onTimeUse',
    align: 'center',
    sorting: false,
    filtering: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rc) => (rc?.onTimeUse ? 'بله' : 'خیر'),
  },
  {
    title: 'درصد مالیات',
    field: 'tax',
    align: 'center',
    filtering: false,
    sorting: false,
    cellStyle: {
      width: '1%',
    },
    headerStyle: {
      width: '1%',
    },
    render: (rd) => rd?.tax ?? '-',
  },

  {
    title: 'گزارش‌گیری',
    field: 'export',
    filtering: false,
    align: 'center',
    sorting: false,
    render: (rd) => (
      <Link to={`/subscriptions/assigned/delegation-details/${rd?.id}`}>
        <Button>نمایش گزارش</Button>
      </Link>
    ),
  },

  ...((actionsList['exclusiveActiveSubscriptionsBtn'] || actionsList['editSubscriptionsBtn']) ? [{
      title: 'عملیات',
      field: 'operationSmall',
      filtering: false,
      sorting: false,
      align: 'right',
      cellStyle: {
        width: '1%',
      },
      headerStyle: {
        width: '1%',
      },
      render: (rowData) => (
        <TableItemActionsNew
          iconButton
          startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
          title=""
          otherMenus={[
            {
              title: 'ویرایش',
              isShow: !!actionsList['editSubscriptionsBtn'],
              onClick: () => {
                onClickEdit(rowData?.id);
              },
            },
            {
              title: 'فعال‌سازی اختصاصی',
              isShow: !!actionsList['exclusiveActiveSubscriptionsBtn'],
              onClick: () => {
                setDedicatedActivation(rowData?.id);
                setSubscriptionType(rowData?.typeCode);
              },
            },
          ]}
        />
      ),
    }] : []),

];

const columnsId = {
  invoiceId: '1349',
  tax: '1444',
  invoiceStatus: '1352',
  guildName: '1353',
  decreased: '1354',
  hasMultiInvoice: '1384',
};

const orderingIndexes = [];
const generateData = (rows, query) => {
  const newData = rows.map((row, key) => {
    return {
      num: query?.page * query?.pageSize + key + 1,
      ...row,
    };
  });

  return newData;
};

export { columns, columnsId, generateData, orderingIndexes };
